import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { UserType } from "../../types/user";
import type { RootState } from "../../types/store";
import { ApolloClientType } from "../../types/apollo";
import { userQuery } from "../../components/Scheduler/scheduler.gql";
import { DoctorData, SchedulesStateType } from "../../types/scheduler";
import { logOut } from "./user";

const initialState: SchedulesStateType<UserType["role"]> = {
  data: null,
  loading: false
};

export const fetchSchedulesData = createAsyncThunk(
  "schedulesData/fetch",
  async ({ doctorData }:{ doctorData?: DoctorData }, { getState, extra }) => {
    const { apolloClient } = extra as { apolloClient: ApolloClientType };
    const { user } = getState() as RootState;

    const role = doctorData?.role || user.role!;
    const { data } = await apolloClient.query({
      query: userQuery[role as keyof typeof userQuery],
      variables: {
        id: Number(doctorData?.id || user.id)
      },
      fetchPolicy: "no-cache"
    });

    return data;
  },
);

export const schedulesSlice = createSlice({
  name: "schedules",
  initialState,
  reducers: {
    reset: (state) => {
      state.data = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSchedulesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchSchedulesData.fulfilled, (state, action) => {
      state.data = action.payload;

      state.loading = false;
    });
    builder.addCase(logOut.fulfilled, (state) => {
      state.data = null;
      state.loading = false;
    });
  }
});

export const isSchedulesLoading = (state: RootState) => state.schedules.loading;
export const schedulesData = (state: RootState) => state.schedules.data;
export const resetSchedulerData = schedulesSlice.actions.reset;
